import { useEffect, useState } from 'react'
//import { UploadBoxSuccess } from '@ui/components/upload-box/upload-box.component.tsx'
import { useMobileContext } from '@hooks/use-mobile-context.ts'
import { type clsMobileState } from '@store/mobile-reducer.ts'
import { ERROR_TEMPLATES, isEXTAllowed, isOverWeight } from '@utils/validators'
import type { UploadBoxSuccess } from './upload-box.component'

export type UploadBoxError = {
	description: string
}

function useUploadBox(
	id: keyof MobileState['steps'],
	side: string,
	onSuccess: UploadBoxSuccess,
	onDelete: (id: string) => void
) {
	const { state } = useMobileContext()
	const [reqFile, setFile] = useState<File | null>()
	const [error, setError] = useState<UploadBoxError | null>(null)

	const fileToSource = (file: File) => {
		setError(null)

		if (!isEXTAllowed(file)) {
			setError({
				description: ERROR_TEMPLATES.mobileNotSupported,
			})
		} else if (isOverWeight(file)) {
			setError({
				description: ERROR_TEMPLATES.mobileOverweight,
			})
		} else {
			setFile(file)
		}
	}

	useEffect(() => {
		const { content } = state.steps[id].documents[side]

		if (content) {
			fileToSource(content)
		}
	}, [])

	const uploadFiles = (files: FileList | null) => {
		const photo = files?.item(0)

		if (photo) {
			fileToSource(photo)
			onSuccess(side, photo)
		}
	}

	const deletePhoto = () => {
		setFile(null)
		onDelete(side)
	}

	return {
		actions: {
			uploadFiles,
			deletePhoto,
		},
		data: {
			error,
			file: reqFile,
		},
	}
}

export { useUploadBox }
